export default __webpack_public_path__ + "static/media/5_template.3c7b9608.svg";